import { Button } from "../../../../Common/AbstractComponents/Button";
import DeclensionNouns from "../../../../Common/DeclensionNouns";
import { Util } from "../../../../Common/Util";
import Vocabulary from "../../../../Common/Vocabulary";

const TIME_RANGE_TYPE = {
    morning: {
        min: 6,
        max: 12,  
    },
    day: {
        min: 12,
        max: 18,
    },
    evening: {
        min: 18,
        max: 24,
    },
    night: {
        min: 0,
        max: 6,
    }
}

export class Filters {
    constructor({ page, lang, updateRoutes, getRoutes }) {
        this.$page = page;
        this._lang = lang;

        this._updateRoutes = updateRoutes;
        this._getRoutes = getRoutes;

        this.$filtersSidebar = $(this.$page).find('.railway_results_sidebar .railway_fiters');
        this.$filterBtn = this.$filtersSidebar.find('button.filter_btn');
        this.$resetBtn = this.$filtersSidebar.find('button.reset_btn');

        this._numberOfTrains = 0;

        this._button = new Button({
            button: this.$filterBtn,
            onClick: this._filter.bind(this),
        });

        this._resetButton = new Button({
            button: this.$resetBtn,
            onClick: this._resetFilters.bind(this),
        })

        this._filtersTemplate = {
            wagon_type: {},
            places_type: {
                all: {
                    id: 0,
                    selected: true,
                    name: Vocabulary[this._lang].train.all,
                    type: 'all',
                },
                lower: {
                    id: 1,
                    selected: false,
                    name: Vocabulary[this._lang].train.lower,
                    type: 'lower',
                },
                upper: {
                    id: 2,
                    selected: false,
                    name: Vocabulary[this._lang].train.upper,
                    type: 'upper',
                },
            },
            departure_time: {
                all_time: {
                    id: 'departure_all_time',
                    selected: true,
                    name: Vocabulary[this._lang].train.all_time,
                    type: 'all_time',
                },
                morning: {
                    id: 'departure_morning',
                    selected: false,
                    name: Vocabulary[this._lang].train.morning,
                    type: 'morning',
                },
                day: {
                    id: 'departure_day',
                    selected: false,
                    name: Vocabulary[this._lang].train.day,
                    type: 'day',
                },
                evening: {
                    id: 'departure_evening',
                    selected: false,
                    name: Vocabulary[this._lang].train.evening,
                    type: 'evening',
                },
                night: {
                    id: 'departure_night',
                    selected: false,
                    name: Vocabulary[this._lang].train.night,
                    type: 'night',
                },
            },
            arrival_time: {
                all_time: {
                    id: 'arrival_all_time',
                    selected: true,
                    name: Vocabulary[this._lang].train.all_time,
                    type: 'all_time',
                },
                morning: {
                    id: 'arrival_morning',
                    selected: false,
                    name: Vocabulary[this._lang].train.morning,
                    type: 'morning',
                },
                day: {
                    id: 'arrival_day',
                    selected: false,
                    name: Vocabulary[this._lang].train.day,
                    type: 'day',
                },
                evening: {
                    id: 'arrival_evening',
                    selected: false,
                    name: Vocabulary[this._lang].train.evening,
                    type: 'evening',
                },
                night: {
                    id: 'arrival_night',
                    selected: false,
                    name: Vocabulary[this._lang].train.night,
                    type: 'night',
                },
            },
        };

        this._filters = {};

        this.init();
    }

    init() {
        const routes = this._getRoutes();
        this._filters = JSON.parse(JSON.stringify(this._filtersTemplate));
        this.$filtersSidebar.find('.railway_fiters_block.change').addClass('_show');

        this._numberOfTrains = routes.length;

        routes.forEach(route => {
            //Формирования фильтров под тип вагона и под виды мест
            if (route.classes.length > 0) {
                this.$filtersSidebar.find('.railway_fiters_block.wagon_type').addClass('_show');

                route.classes.forEach(wagon => {
                    //Типы вагонов
                    if (!this._filters.wagon_type.hasOwnProperty(wagon.car_type)) {
                        this._filters.wagon_type[wagon.car_type] = {count: 1, selected: false, name: wagon.name, cost: wagon.cost ? wagon.cost : 0};
                    } else {
                        this._filters.wagon_type[wagon.car_type].count = this._filters.wagon_type[wagon.car_type].count + 1;
                        this._filters.wagon_type[wagon.car_type].cost = this._filters.wagon_type[wagon.car_type].cost === 0 || this._filters.wagon_type[wagon.car_type].cost === null || this._filters.wagon_type[wagon.car_type].cost > wagon.cost ? wagon.cost : this._filters.wagon_type[wagon.car_type].cost;
                    }
                });
                
            }
        });

        this._renderFilters();
    }

    _renderFilters() {
        for (const key in this._filters) {
            const renderBlock = this.$filtersSidebar.find(`.railway_fiters_block.${key}`);

            let filters = '';

            for (let filter_name in this._filters[key]) {
                const value = filter_name;
                const name = this._filters[key][filter_name].name;
                const cost = !this._filters[key][filter_name].cost ? '' : `<span class="_input_checkbox__label_price">від ${this._filters[key][filter_name].cost} грн</span>`;

                if (key === 'wagon_type') {
                    filters += `
                        <div class="_input_checkbox">
                            <input type='checkbox' name='${name}' value='${value}' id='${value}'>
                            <label for='${value}'>
                                <span>${name} ${cost}</span>
                            </label>
                        </div>
                    `;
                } else {
                    filters += `
                        <div class="_radio">
                            <input type="radio" name="${key}" value='${value}' id="${this._filters[key][filter_name].id}" ${this._filters[key][filter_name].selected ? 'checked' : ''}>
                            <label for="${this._filters[key][filter_name].id}">
                                <span>${name}</span>
                            </label>
                        </div>
                    `;
                }
            }

            renderBlock.find('.filters_list').html(filters);
        }
    }

    _filter() {
        const selectedCheckox = this.$filtersSidebar.find('input:checked');
        if (selectedCheckox.length === 0) return $(this.$page).find('.bus_results_item').show();
        this._resetFilterValues(this._filters);

        selectedCheckox.each((index, filter) => {
            const type = $(filter).closest('.railway_fiters_block').data('filter');
            this._filters[type][$(filter).val()].selected = true;
        });

        const routes = this._getRoutes();
        //TODO::тут перемудрил с формированием фильтров и фильтрацией, нужно будет сделать по другому
        routes.forEach(route => {
            const routeElement = $(this.$page).find(`.railway_results_item[data-routeid="${route.number}"]`);

            let routeShow = true;

            const selectedWagon = Object.values(this._filters.wagon_type).findIndex(wagon => wagon.selected);
            if (route.classes.length > 0 && selectedWagon !== -1) {
                const index = route.classes.findIndex(wagon => this._filters.wagon_type[wagon.car_type].selected);
                if (index === -1) routeShow = false;
            } 

            const selectedDepartureTime = Object.values(this._filters.departure_time).find(time => time.selected);
            const selectedArrivalTime = Object.values(this._filters.arrival_time).find(time => time.selected);

            if (routeShow && selectedDepartureTime.type === 'all_time' && selectedArrivalTime.type === 'all_time') {
                return routeElement.show();
            }

            if (routeShow && selectedDepartureTime.type === 'all_time' && this._checkDate(route.arrival_time, selectedArrivalTime.type)) {
                return routeElement.show();
            }

            if (routeShow && selectedArrivalTime.type === 'all_time'&& this._checkDate(route.departure_time, selectedDepartureTime.type)) {
                return routeElement.show();
            }

            if (routeShow && selectedDepartureTime.type !== 'all_time' && selectedArrivalTime.type !== 'all_time' && this._checkDate(route.departure_time, selectedDepartureTime.type) && this._checkDate(route.arrival_time, selectedArrivalTime.type)) {
                this._numberOfTrains += 1;
                return routeElement.show();
            }

            return routeElement.hide();
        });

        this._numberOfTrains = $(this.$page.find('.railway_results_item:not([style*="display: none"])')).length;

        $(this.$page).find('.flights_count').html(`<span class="number_flights">${this._numberOfTrains}</span> ${DeclensionNouns(this._numberOfTrains, Vocabulary[Util.getCurrentLang()].routes_count.split('|'))} ${Vocabulary[Util.getCurrentLang()].found}`);
    }

    _resetFilterValues(filters) {
        for(let key in filters) {
            if (!filters[key].hasOwnProperty('selected')) {
                this._resetFilterValues(filters[key])
            } else {
                filters[key].selected = false;
            }
        }

        return filters;
    }

    _resetFilters() {
        this._resetFilterValues(this._filters);
        const routes = this._getRoutes();
        this.$numberOfTrains = routes.length;
        $(this.$page).find('.flights_count').html(`<span class="number_flights">${this._numberOfTrains}</span> ${DeclensionNouns(this._numberOfTrains, Vocabulary[Util.getCurrentLang()].routes_count.split('|'))} ${Vocabulary[Util.getCurrentLang()].found}`);
        $(this.$page).find('.railway_results_item').show();
        $(this.$filtersSidebar).find('input[type="checkbox"]').prop('checked', false);
    }

    hide() {
        this.$filtersSidebar.find('.railway_fiters_block').removeClass('_show');
        $(this.$filtersSidebar).hide();
    }

    show() {
        $(this.$filtersSidebar).show();
    }

    _checkDate(time, filterDate) {
        const timeRange = TIME_RANGE_TYPE[filterDate];
        const hour = +time.substr(0, 2);

        return hour >= timeRange.min && hour < timeRange.max ? true : false
    }
}